import { useEffect, useState } from "react";
import api from "@/lib/api";

// Shared in-memory cache so Header/Footer/WhatsAppButton/Logo don't refetch.
let _cache = null;
const _subs = new Set();
let _loading = null;

async function _fetch(force = false) {
  if (!force && _cache) return _cache;
  if (_loading) return _loading;
  _loading = api
    .get("/settings")
    .then((r) => {
      _cache = r.data || {};
      _subs.forEach((cb) => cb(_cache));
      return _cache;
    })
    .catch(() => {
      _cache = {};
      _subs.forEach((cb) => cb(_cache));
      return _cache;
    })
    .finally(() => { _loading = null; });
  return _loading;
}

export function refreshSiteSettings() {
  return _fetch(true);
}

export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache || {});
  useEffect(() => {
    const cb = (s) => setSettings({ ...s });
    _subs.add(cb);
    _fetch();
    return () => { _subs.delete(cb); };
  }, []);
  return settings;
}
